import '../styles/index.scss';
import 'bootstrap';

//lib js
import $ from "jquery";
import fullpage from "fullpage.js";
import slick from "slick-carousel";

// $('#loading').css("opacity", "1");
//full page js custom
$(document).ready(function() {
   
    var $isAnimatedPage3 = $('.page3 .is-animated'),
        $isAnimatedPage3_text = $('.page3 .is-animated-text'),
        $isAnimatedPage3_left = $('.page3 .is-animated_page3-left'),
        $isAnimatedPage3_right = $('.page3 .is-animated_page3-right'),
        $isAnimatedPage3_text_mobile = $('.page3 .is-animated-text-mobile'),
        $isAnimatedPage3_left_mobile = $('.page3 .is-animated_page3-left-mobile'),
        $isAnimatedPage3_right_mobile = $('.page3 .is-animated_page3-right-mobile'),
        $isAnimatedPage3_center_mobile = $('.page3 .is-animated_page3-center-mobile'),

        //page 4     
        $isAnimatedPage4_left = $('.page4 .is-animated-page4_left'),      
        $isAnimatedPage4_right = $('.page4 .is-animated-page4_right'),
        $isAnimatedPage4_mobile = $('.page4 .is-animated-page4_mobile'),

        //page 2     
        $isAnimatedPage2_left = $('.page2 .is-animated_page2-left'),    
        $isAnimatedPage2_right = $('.page2 .is-animated_page2-right'),
        
        //page5
        $isAnimatedPage5_left = $('.page5 .is-animated_page5-left'),    
        $isAnimatedPage5_bottom = $('.page5 .is-animated_page5-bottom'),    
        $isAnimatedPage5_right = $('.page5 .is-animated_page5-right'),      
        $isAnimatedPage5_footer = $('.page5 .is-animated_page5-footer');      

    setTimeout(function() {
        
        var count = 0;
        
        $('#fullpage').fullpage({
          //set color for each page
          sectionsColor: ['#fff', '#000', '#fff', '#000', '#fff'],
          menu: '.menu',
          navigation : true,
          slidesNavigation :true,
          showActiveTooltip :true,
          navigationTooltips: [
          'Home', 'About', 'What we do','Our products','Contact us'],
          isResponsive:true,
          autoScrolling:true,
          
          responsiveWidth: 0,
          responsiveHeight: 0,
          responsiveSlides: false,

          onLeave: function(index, nextIndex, direction) {
            //page2
            if(index == 1 && nextIndex == 2){
              $isAnimatedPage2_right.addClass('animated fadeInRight'); 
              $isAnimatedPage2_right.eq(0).css('animation-delay', '0.5s');

              $isAnimatedPage2_left.addClass('animated fadeInLeft'); 
              $isAnimatedPage2_left.eq(0).css('animation-delay', '0.5s');
              // $isAnimatedPage2_left.eq(1).css('animation-delay', '1s');
              // $isAnimatedPage2_left.eq(2).css('animation-delay', '1.5s');
              // $isAnimatedPage2_left.eq(3).css('animation-delay', '2s');
              count++;
              if (count === 1) {
                var elements = document.getElementsByClassName('txt-rotate');
                // console.log(elements);
                for (var i = 0; i < elements.length; i++) {
                  var toRotate = elements[i].getAttribute('data-rotate');
                  // console.log(toRotate);
                  var period = elements[i].getAttribute('data-period');
                  if (toRotate) {
                    new TxtRotate(elements[i], JSON.parse(toRotate), period);
                  }
                }
                // INJECT CSS
                var css = document.createElement("style");
                css.type = "text/css";
                css.innerHTML = ".txt-rotate > .wrap { border-right: 0.08em solid #666 }";
                document
                  .body
                  .appendChild(css);
              }
              

            }
            // first animation
            else if (index == 2 && nextIndex == 3) {
              //page 3
              $isAnimatedPage3.addClass('animated fadeInDownCustom'); 
              $isAnimatedPage3.eq(0).css('animation-delay', '.0.3s');

              $isAnimatedPage3_left.addClass('animated fadeInLeftCustom1'); 
              $isAnimatedPage3_left.eq(0).css('animation-delay', '0.7s');
              // $isAnimatedPage3_left.eq(2).css('animation-delay', '1.2s');
              // $isAnimatedPage3_left.eq(3).css('animation-delay', '1.7s');

              $isAnimatedPage3_right.addClass('animated fadeInRightCustom1'); 
              $isAnimatedPage3_right.eq(0).css('animation-delay', '0.7s');
              // $isAnimatedPage3_right.eq(1).css('animation-delay', '2.7s');
              // $isAnimatedPage3_right.eq(2).css('animation-delay', '3.2s');

              $isAnimatedPage3_text.addClass('animated fadeInUpCustom'); 
              $isAnimatedPage3_text.eq(0).css('animation-delay', '0.7s');


              //mobile
              $isAnimatedPage3_center_mobile.addClass('animated fadeInDownCustomMobile'); 
              $isAnimatedPage3_center_mobile.eq(0).css('animation-delay', '.0.3s');

              $isAnimatedPage3_left_mobile.addClass('animated fadeInLeftCustom2'); 
              $isAnimatedPage3_left_mobile.eq(0).css('animation-delay', '0.7s');
              $isAnimatedPage3_left_mobile.eq( 1 ).css('animation-delay', '0.7s');
              $isAnimatedPage3_left_mobile.eq(2).css('animation-delay', '0.7s');

              $isAnimatedPage3_right_mobile.addClass('animated fadeInRightCustom2'); 
              $isAnimatedPage3_right_mobile.eq(0).css('animation-delay', '0.7s');
              $isAnimatedPage3_right_mobile.eq(1).css('animation-delay', '0.7s');
              $isAnimatedPage3_right_mobile.eq(2).css('animation-delay', '0.7s');

              $isAnimatedPage3_text_mobile.addClass('animated fadeInUp'); 
              $isAnimatedPage3_text_mobile.eq(0).css('animation-delay', '0.7s');

             
            }
            else if(index == 3 && nextIndex == 4 ){
              $isAnimatedPage4_left.addClass('animated fadeInLeft'); 
              $isAnimatedPage4_left.eq(0).css('animation-delay', '.0.5s');

              $isAnimatedPage4_right.addClass('animated fadeInRight'); 
              $isAnimatedPage4_right.eq(0).css('animation-delay', '0s');

              //mobile
              $isAnimatedPage4_mobile.addClass('animated fadeInDown'); 
              $isAnimatedPage4_mobile.eq(0).css('animation-delay', '0s');
            }
            
            //page5
            else if(index == 4 && nextIndex == 5){
              $isAnimatedPage5_right.addClass('animated fadeInRight'); 
              $isAnimatedPage5_right.eq(0).css('animation-delay', '0.5s');

              $isAnimatedPage5_bottom.addClass('animated fadeInUp'); 
              $isAnimatedPage5_bottom.eq(0).css('animation-delay', '0.5s');

              $isAnimatedPage5_left.addClass('animated fadeInLeft'); 
              $isAnimatedPage5_left.eq(0).css('animation-delay', '0.5s');

              $isAnimatedPage5_footer.addClass('animated fadeInUp'); 
              $isAnimatedPage5_footer.eq(0).css('animation-delay', '1s');
            }

          },

          
          afterLoad: function(anchorLink, index){
            console.log('after load');
            
            if($(".content-service-mobile").hasClass("active")){
                $(".content-service-mobile.active").removeClass("active");
                $(".description_page3-mobile").css("opacity","1");
                $(".front-mobile").removeClass("active");
            }
            $(".description_page3-mobile").css("opacity","1");

            // console.log(index);
            //kiem tra trang o vi tri trang nao
              if(index % 2 == 0){ 
                  // console.log("chan");
                  $(".logo").find(".dark").addClass("active");
                  $(".logo").find(".light").removeClass("active");
                  $(".menu-close").css("color","#fff");

                  $("#fp-nav li .fp-tooltip").on("mouseover",function(){
                    $(this).closest("li").find(".fp-tooltip").css("color","#fff");
                    if($(this).closest("li").find("a").hasClass("active")){
                        $(this).closest("li").find(".fp-tooltip").css("color","#fff")
                    }
                  })

                  $("#fp-nav li .fp-tooltip").on("mouseout",function(){
                      $(this).closest("li").find(".fp-tooltip").css("color","#7f7f7f")
                  })
              }else{
                // console.log("le");
                  $(".logo").find(".light").addClass("active");
                  $(".logo").find(".dark").removeClass("active");
                  $(".menu-close").css("color","#000");
                  $("#fp-nav li .fp-tooltip").on("mouseover",function(){
                    $(this).closest("li").find(".fp-tooltip").css("color","#000");
                  })

                  $("#fp-nav li .fp-tooltip").on("mouseout",function(){
                      $(this).closest("li").find(".fp-tooltip").css("color","#7f7f7f")
                  })
              }
            
            },
        });
    },3800);

	    //click to next page
      $(document).on('click', '.next_2', function(){
        $.fn.fullpage.moveSectionDown();
      });

      //move to top
      $(document).on('click', '.to_top', function(){
        $.fn.fullpage.moveTo(1);
      });

      //click logo run to top
      $(document).on('click', '#imgLogo', function(){
        $.fn.fullpage.moveTo(1);
      });

});

//menu mobile
$(window).ready(function() {
  if($(window).width() <= 768 ){
    $("body").append("<a class='menu-close'>Menu</a>")

    // var footer_mobile = '<div class="footer-mobile">' 
    //   + '<a class="icon"><img src=' + require("../icons/ic-twitter-white.svg") + '></a>'
    //   + '<a class="icon"><img src=' + require("../icons/ic-facebook-white.svg") + '></a>'
    //   + '<a class="icon"><img src=' + require("../icons/ic-linkedin-white.svg") + '></a>'
    //       '</div>'
        
    $("body").append(footer_mobile)

  }else{
    // console.log(false)
  }
})


//menu mobile==========================================================================
$(document).ready(function() {
  $(".menu-close").click(function(e){
    e.stopPropagation();
    $(".fp-show-active").toggleClass("active"); 

    if($("#fp-nav").hasClass("active")){
      $(".menu-close").addClass("active");
      // $(".menu-close").html("Close");
      $(".footer-mobile").addClass("active");
      $(".container-fluid").css({"transform": "translateX(-150px)", "transition": "all 0.5s"})
    }else{
       $(".menu-close").removeClass("active");
      //  $(".menu-close").html("Menu");
       $(".footer-mobile").removeClass("active");
       $(".container-fluid").css({"transform": "translateX(0)", "transition": "all 0.5s"})
    }
    
  })
})

$(window).click(function(){
    $(".fp-show-active").removeClass("active");
    $(".menu-close").removeClass("active");
    $(".container-fluid").css("transform","none");
    $(".footer-mobile").removeClass("active");
})

// typing carousel==========================================
var TxtRotate = function (el, toRotate, period) {
				this.toRotate = toRotate;
				this.el = el;
				this.loopNum = 0;
				this.period = parseInt(period, 10) || 2000;
				this.txt = '';
				this.tick();
				this.isDeleting = false;
};

var TxtRotate = function(el, toRotate, period) {
  this.toRotate = toRotate;
  this.el = el;
  this.loopNum = 0;
  this.period = parseInt(period, 10) || 2000;
  this.txt = '';
  this.tick();
  this.isDeleting = false;
};

TxtRotate.prototype.tick = function() {
  var i = this.loopNum % this.toRotate.length;
  var fullTxt = this.toRotate[i];
	// console.log(i);
  if (this.isDeleting) {
    this.txt = fullTxt.substring(0, this.txt.length - 1);
  } else {
    this.txt = fullTxt.substring(0, this.txt.length + 1);
  }

	//custom
  if(i == 0 ){
		this.el.innerHTML = '<span class="wrap red">' + this.txt + '</span>';
  }
  else if(i == 1 ){
		this.el.innerHTML = '<span class="wrap yellow">' + this.txt + '</span>';
  }
  else if(i == 2 ){
		this.el.innerHTML = '<span class="wrap passion">' + this.txt + '</span>';
  }
  else if(i == 3 ){
		this.el.innerHTML = '<span class="wrap pink">' + this.txt + '</span>';
  }
  else if(i == 4 ){
		this.el.innerHTML = '<span class="wrap blue">' + this.txt + '</span>';
  }
  else if(i == 5 ){
		this.el.innerHTML = '<span class="wrap purle">' + this.txt + '</span>';
  }

  var that = this;
  var delta = 300 - Math.random() * 100;

  if (this.isDeleting) { delta /= 2; }

  if (!this.isDeleting && this.txt === fullTxt) {
    delta = this.period;
    this.isDeleting = true;
  } else if (this.isDeleting && this.txt === '') {
    this.isDeleting = false;
    this.loopNum++;
    delta = 500;
  }

  setTimeout(function() {
    that.tick();
  }, delta);
};


$(".child").on("mouseover",function(){
  $(this).closest("td").find(".before").css("transform","rotateY(180deg)")
  $(this).closest("td").find(".after").css({'transform':'rotateY(4deg) rotate(-45deg)','z-index':'2'})
})
$(".child").on("mouseleave",function(){
  $(this).closest("td").find(".before").css("transform","rotateY(0deg)")
  $(this).closest("td").find(".after").css({'transform':'rotateY(4deg) rotate(-45deg)','z-index':'0'})
})


//submit form have idea
$("#form_Send_idea").submit(function(e){
  e.preventDefault();
    var email = $("input[name='email']").val()
    var mess = $("textarea[name='message']").val()
    if(email && mess != ''){
      var api = $("#form_Send_idea").data("api");
      $.ajax({
        url: api,
        type: 'POST',
        dataType: 'json',
        data: {
          action:'send_contact_form',
          email: $("input[name='email']").val(),
          message: $("textarea[name='message']").val(),
        },
        success: function(data) {
            $("#fullpage").append("<div class='submit-successfull'> Your message has been sent!</div>");

            setTimeout(() => {
              $(".submit-successfull").css('opacity',"0");
              $("#form_Send_idea")[0].reset();
            }, 3000);
          
          // location.reload();
        },
        error: function(err) {
          console.log(err);
        }
      });
    }else{
      alert("Input Form, Please!")
    }
    // console.log(email)
})


//service mobile==================================================
$(".front-mobile").on("click mouseenter",function(){
  $(".front-mobile").removeClass("active");
  $(".description_page3-mobile").css("opacity","0");

  if($(this).hasClass("active")){
      $(this).removeClass("active");
      if($(this).closest(".flip_mobile").find(".content-service-mobile").hasClass("active")){
        $(".content-service-mobile").removeClass("active");
      }
      $("table.test").css("margin-top", "0");
      $(".description_page3-mobile").css({"opacity":"0"});
  }else{
      $(this).addClass("active");
      $(this).closest(".flip_mobile").find(".content-service-mobile").addClass("active")
    }
})

$(".content-service-mobile .images").click(function(){
  $(this).closest(".content-service-mobile").removeClass("active");
  $("table.test .front-mobile").removeClass("active");
  $(".description_page3-mobile").css("opacity","1");
})

//content for service=========================================================================================
var data_service = [
  {
    "title": "Multi platform development",
    "description" : "Building businesses by actualizing our clients’ ideas into innovative products"
  }, {
    "title": "Product definition",
    "description": "Starting from zero and growing our clients' product into a tangible business"
  }, {
    "title": "Product rollout",
    "description": "Wide network of the right people with years of cultivated how-to knowledge"
  }, {
    "title": "DESIGN TEAMS",
    "description": "User-centric design teams to turn your concepts into fully refined designs"
  }, {
    "title": "DEVELOPMENT TEAMS",
    "description": "Access to a global range of teams to build products following agile methodologies"
  }, {
    "title": "DOMAIN EXPERTISE",
    "description": "Digital expert teams with years spent building connections in the tech industry"
  }
]
//end service mobile============================================================================================================

//replay content for service mobile
$(".front-mobile").on("click mouseenter",function(){
  var old = $(".content-service-mobile .title").html();
  var data_content = $(this).data("content");
  
  var res_title = old.replace(old,data_service[data_content].title);
  var res_des = old.replace(old,data_service[data_content].description);

  $(".content-service-mobile .title").html(res_title);
  $(".content-service-mobile .description").html(res_des);
})


//slider
$(window).on("load",function(){
    $(".slider-leap-info").slick({
        slidesToShow: 1, 
        dots: true, 
        arrows: false,  
        autoplay: true, 
        autoplaySpeed:3000,
        responsive: [
          {
            breakpoint: 768, //at 600px wide, only 2 slides will show
            settings: {
              slidesToShow: 1
            }
          },
        ]
    })

    $(".slider").slick({
        slidesToShow: 1, 
        dots: true, 
        arrows: false,  
        autoplay: true,
        autoplaySpeed:3000,
        responsive: [
          {
            breakpoint: 768, //at 600px wide, only 2 slides will show
            settings: {
              slidesToShow: 1
            }
          },
        ]
    })

    $(".slidermain").slick({
        slidesToShow: 1, 
        dots: false, 
        arrows: true,  
        infinite:false,
        autoplay: false,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        draggable: 'false',
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        draggable: false,
        accessibility: false,
    })

    //tab on slider mobile====================================================
    $('.tab_arrow .next').on('click', function(e) {
        $(this).addClass('active');
        $(this).closest('.tab_arrow').find('.prev').addClass('active');
        $(this).closest('.tab_arrow').find('.next').removeClass('active');
        // $(this).closest('.tab_custom').find('.tab-2').addClass('active');
        // $(this).closest('.tab_custom').find('.tab-1').removeClass('active');
    });
    $('.tab_arrow .prev').on('click', function(e) {
        $(this).addClass('active');
        $(this).closest('.tab_arrow').find('.next').addClass('active');
        $(this).closest('.tab_arrow').find('.prev').removeClass('active');
        // $(this).closest('.tab_custom').find('.tab-2').removeClass('active');
        // $(this).closest('.tab_custom').find('.tab-1').addClass('active');
    });
})


//event next tab for page 4
// $(".tab_arrow .right").click(function () {
//     $(this).closest(".tab_custom").find("li.tab-1").removeClass("active")
//     $(this).closest(".tab_custom").find("li.tab-2").addClass("active")

//     $(".tab_content2").css("opacity", "1");

//     // console.log($(this).closest(".tab_arrow").html())

//     $(this).closest(".content_left").find(".tab_content2").show()
//     $(this).closest(".content_left").find(".tab_content1").hide()
//     $(".tab_arrow .left").addClass("active");
//     $(this).removeClass("active");
// })
// $(".tab_arrow .left").click(function () {
//     $(this).closest(".tab_custom").find("li.tab-1").addClass("active")
//     $(this).closest(".tab_custom").find("li.tab-2").removeClass("active")
//     $(this).closest(".content_left").find(".tab_content1").show()
//     $(this).closest(".content_left").find(".tab_content2").hide()
//     $(".tab_arrow .right").addClass("active");
//     $(this).removeClass("active");
// })


//form contact =============================================================================
$(".form-idea .input-container").append("<p class='fieldset'> &lt;Email&gt; </p>")
$(".form-idea .textarea-container").append("<p class='fieldset'> &lt;Message&gt; </p>")

$(".input-container input").on('focusin',function(){
    $(this).closest(".input-container").find(".fieldset").css({
      "opacity":"1"
    })
})
$(".input-container input").on('focusout',function(){
    $(this).closest(".input-container").find(".fieldset").css("opacity","0")
})
$(".textarea-container textarea").on('focusin',function(){
    $(this).closest(".textarea-container").find(".fieldset").css({
      "opacity":"1"
    })
})
$(".textarea-container textarea").on('focusout',function(){
    $(this).closest(".textarea-container").find(".fieldset").css("opacity","0")
})


$(document).ready(function(){
    // console.log($(window).height())

    $(window).on("resize" , function(){
      var height_window = $(window).height(); 
      var height_slider1 = height_window / 2;
      // if($(window).outerHeight() <= 480){
      //   $(".slider1").css("height",height_slider1)  
      // }else{
      //   $(".slider1").css("height",height_slider1 - 40)
      // }
      // console.log(height_slider1)
  
      // var height_slider2 = (height_window + 150)/2;
      // $(".slider").css("height",height_slider2);
      // console.log(height_slider2);

      
    });
    //amination for logo
    setTimeout(function() {
        $(".logo").css({transform:'translateY(0)'},"swing").addClass('animated fadeIn');    
    }, 3500);
    
    //amination for text static on page 1
    setTimeout(function() {
        $(".page1 .autotext .text-static").css({transform:'scale(1)'},"slow").addClass('animated zoomIn');
    }, 0);

    //amination for images on page 1
    setTimeout(function() {
        $(".page1  .content  .images").css({transform:'scale(1)'},"slow").addClass('animated zoomIn');
    }, 0);
});


var loading_page = false,
    load_after = false;

// $('#loading').show();
 $(window).on('load',function() {

      setTimeout(() => {
        $('#loading').css({"opacity": "0", "z-index":"0", 'display':'none'});
      }, 4000);
              
  
      $('body').bind('scroll', function(e){
        e.preventDefault();
      });  

       //page 1 run text
       var txt = $(".auto_run").text();
       var i = 0; 
       var speed = 70;
       $(".auto_run").text("");
       var isRunning = false;
       
       setTimeout(function() {
         

         function showText(){
           if (i < txt.length) {
             $(".auto_run").text($(".auto_run").text() + txt.charAt(i) );
             i++;
             setTimeout(showText, speed);
           }
         }

         showText();
       }, 4000);
     
});




// WEBPACK FOOTER //
// ./src/scripts/index.js